import { render, staticRenderFns } from "./CleanLessonsView.vue?vue&type=template&id=3857b50a&"
import script from "./CleanLessonsView.vue?vue&type=script&lang=js&"
export * from "./CleanLessonsView.vue?vue&type=script&lang=js&"
import style0 from "./CleanLessonsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VDivider,VProgressCircular,VRow,VSpacer})
